import { useNavigate } from "react-router-dom";
import { FooterContour } from "../Contours/FooterContour";
import SocialProof from "../Output/SocialProof";

interface WebNavFooterProps {
	showContour?: boolean;
	showLinks?: boolean;
}

export function WebNavFooter({
	showContour = true,
	showLinks = true
}: WebNavFooterProps) {
	const navigate = useNavigate();

	const handleNavigate = (path: string) => {
		navigate(path);
		window.scrollTo(0, 0);
	};

	if (!showContour && !showLinks) {
		return null;
	}

	return (
		<div className="relative w-full h-40 mt-auto">
			{/* Background contour */}
			{showContour && (
				<div className="absolute inset-0">
					<FooterContour />
				</div>
			)}

			{/* Foreground content */}
			{showLinks && (
				<div className="relative z-footer h-full flex flex-col items-center justify-center space-y-4 text-primary">
					{/* Navigation links */}
					<div className="flex flex-col gap-2 text-sm">
						<div className="flex gap-6 justify-center">
							<button
								onClick={() => handleNavigate("/mission")}
								className="hover:text-primary-active cursor-pointer"
							>
								Mission
							</button>
							<button
								onClick={() => handleNavigate("/careers")}
								className="hover:text-primary-active cursor-pointer"
							>
								Careers
							</button>
						</div>
						<div className="flex gap-6 justify-center">
							<button
								onClick={() => handleNavigate("/terms")}
								className="hover:text-primary-active cursor-pointer"
							>
								Terms
							</button>
							<button
								onClick={() => handleNavigate("/privacy")}
								className="hover:text-primary-active cursor-pointer"
							>
								Privacy
							</button>
						</div>
					</div>

					{/* Social Media Links */}
					<div className="flex gap-4 justify-center">
						<SocialProof link="https://www.linkedin.com/company/jobmapwork/" />
						<SocialProof link="https://x.com/jobmap_" />
						<SocialProof link="https://www.facebook.com/people/JobMap/61582574666300/" />
						<SocialProof link="https://www.instagram.com/jobmap_" />
					</div>

					{/* Copyright */}
					<div className="text-xs text-primary-inactive">
						© 2025 JobMap. All rights reserved.
					</div>
				</div>
			)}
		</div>
	);
}
